// extracted by mini-css-extract-plugin
export var list = "NavigationLinks-module--list--24Ozv";
export var list__item = "NavigationLinks-module--list__item--28UxW";
export var list__item__link = "NavigationLinks-module--list__item__link--2bzQ-";